import React from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import Loader from "./Loader";

const Datatable = ({ columns, data, filter, loading  ,onRowClicked}) => {
  // console.log("data", data)
  const noDataImage = "/assets/img/no-data.png";

  const handleTableRef = (node) => {
    if (node) {
      const searchInput = node.querySelector('.data-table-extensions-filter input');
      if (searchInput && searchInput.placeholder !== 'Search here') {
        searchInput.placeholder = 'Search here';
      }
    }
  };

  return (
    <div className="datatable-container" ref={handleTableRef}>
      {loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : data.length === 0 ? (
        <div className="text-center">
          <img
            src={noDataImage}
            alt="No records available"
            style={{ width: '250px', height: 'auto', objectFit: 'contain' }}
          />
          <p className='fs-16'>There are no records to display</p>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={data}
          fixedHeader
          fixedHeaderScrollHeight="500px"
          highlightOnHover={!!onRowClicked}
          noDataComponent={
            <div className="text-center">
              <img
                src={noDataImage}
                alt="No records available"
                style={{ width: '250px', height: 'auto', objectFit: 'contain' }}
              />
              <p className='fs-16'>There are no records to display</p>
            </div>
          }

          onRowClicked={onRowClicked}
          //pointerOnHover={!!onRowClicked}
          pointerOnHover={onRowClicked}
        />
      )}
    </div>
  );
};

export default Datatable;
